import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=57d6cb56"
import script from "./Module.vue?vue&type=script&lang=js"
export * from "./Module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d6cb56')) {
      api.createRecord('57d6cb56', component.options)
    } else {
      api.reload('57d6cb56', component.options)
    }
    module.hot.accept("./Module.vue?vue&type=template&id=57d6cb56", function () {
      api.rerender('57d6cb56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Module.vue"
export default component.exports